const powerReviewsQuotes = () => {
    $('.pr-review-engine .pr-header .pr-review-sort-box select option:nth-child(5), .pr-review-engine .pr-header .pr-review-sort-box select option:nth-child(6)').remove();
    $('.pr-review-main-wrapper').append('<i class="icon-quotes icon-quote-left"></i> <i class="icon-quotes icon-quote-right"></i>');
};

const powerReviews_all = () => {
	if($('#pr-reviewsnippet').length > 0 && $('#pr-reviewlist').length > 0 && $('#pr-reviewsnippet').length > 0){
		var reviewListDiv = $('#pr-reviewlist'),
			powerReviewsAPIKey = reviewListDiv.data('powerreviewsapikey'),
			powerReviewsMerchantId = reviewListDiv.data('powerreviewsmerchantid'),
			powerReviewsMerchantGroupId = reviewListDiv.data('powerreviewsmerchantgroupid'),
			partnumber = $('.item-number').text(),
			keyword = document.URL.split('/')[4],
			catentryId = document.URL.split('/')[5],
			writeAReviewURL = 'https://www.dillards.com/webapp/wcs/stores/servlet/ReviewForm?langId=-1&storeId=301&catalogId=301&partNumber='+partnumber+'&pr_source=web&langId=-1&catalogId=301&storeId=301&productId='+catentryId+'&productKeyword=' + keyword,
			productImage = 'https:' + $('.mainProductImage img').data('fullimage'),
			productURL = 'https://www.dillards.com/p/' + keyword + '/' + catentryId;
//			partnumber = '04175452';//for testing only
		var feedlessProduct={
			'name': dataLayer.product.name,
			'url': productURL,
			'description': $("#description-panel .panel-body").text(),
			'brand_name': dataLayer.product.brand,
			'in_stock': (dataLayer.itemInfo.length > 0)?1:0,
			'manufacturer_id': dataLayer.product.DMS.split(':')[2],
			'image_url': productImage,
			'variants': []
		};
		$.each(dataLayer.itemInfo, function(){
			var newUPC = this.upc;
	        var maxUpcLength = 12;
	        var diff =  maxUpcLength - newUPC.length; 
	         if(diff < 0){
	        	 newUPC = newUPC.substring((diff * -1));
	        }
			var variant = {
				'page_id_variant': dataLayer.product.partNumber + '-' + this.sku,
				'price': this.offerPrice,
				'image_url': 'https://dimg.dillards.com/is/image/DillardsZoom/zoom/' + keyword + '/' + this.image + '.jpg',
				'upc':newUPC
			}
			feedlessProduct.variants.push(variant);
		});
		POWERREVIEWS.display.render ({
		    api_key: powerReviewsAPIKey,
		    locale: 'en_US',
		    merchant_group_id: powerReviewsMerchantGroupId,
		    merchant_id: powerReviewsMerchantId,
		    page_id: partnumber,
		    review_wrapper_url: writeAReviewURL,
		    REVIEW_DISPLAY_LIST_TYPE:'CONDENSED',
		    product:feedlessProduct,
		    on_render: function(config, data) {
//		        console.log(config);
//		        console.log(data);
		    },
		    on_back_to_top_click: function() {
//		        console.log('Back to top has been clicked');
		    },
		    components: {
		        ReviewSnippet: 'pr-reviewsnippet', //render top starts/review count 
		        ReviewSnapshot: 'pr-reviewsnapshot', //displays the aggregate rating data (histogram)
		        ReviewList: 'pr-reviewlist' //display list of detailed individual reviews 
	//        	ReviewDisplay: 'pr-reviewdisplay' //combines the ReviewSnapshot and ReviewList
		    }
		});
	} else if($('#pr-write').length > 0){
		var contentArea = $('#content-area'),
			partnumber = contentArea.data('partnumber'),
			APIKey = contentArea.data('powerreviewsapikey'),
			merchatId = contentArea.data('powerreviewsmerchantid'),
			merchantGroupId = contentArea.data('powerreviewsmerchantgroupid'),
			emuid = contentArea.data('emuid'),
			source = contentArea.data('source'),
			returnUrl = 'https://' + document.URL.split('/')[2],
			backToLink = $('#backToBrowse .back-link a');
		if(backToLink.length > 0 && backToLink.attr('href').length > 0){
			returnUrl += $('#backToBrowse .back-link a').attr('href');
		}
		
		var reviewRender = {
				api_key: APIKey,
				locale: 'en_US',
				merchant_group_id:merchantGroupId,
				merchant_id: merchatId,
				page_id: partnumber,
				return_url: returnUrl,
				source: source,
				on_submit: function(config, data) {
                    window.scrollTo(0,0);
                },
				components: {
					Write: 'pr-write'
				}
			};
//		if(typeof emuid != 'undefined' && emuid.length > 0){
//			reviewRender.merchant_user_email = emuid;
//		}
		
		POWERREVIEWS.display.render(reviewRender);
	}
};

const powerReviews_dt = () => {
    $('#power-review-wrapper').on('click', '.pr-page-prev a, .pr-page-next a, .pr-review-sort-box select', function() {
        setTimeout(function() {
            powerReviewsQuotes();
        }, 800);
    });
}

export {
    powerReviews_all,
    powerReviews_dt
};
